import { PageLink, PageTitle } from '_metronic/layout/core';
import { FC } from 'react';
import { useLocation } from 'react-router-dom';
import { UsuariosView } from './components/usuariosView';



const UsuariosPage: FC = () => {
  let location = useLocation();
  const breadCrumbs: Array<PageLink> = [
    {
      title: 'Configuración',
      path: location.pathname,
      isSeparator: false,
      isActive: true,
    },
    {
      title: 'Usuarios',
      path: '',
      isSeparator: true,
      isActive: false,
    },
  ];

  return (
    <>
      <PageTitle breadcrumbs={breadCrumbs}>Usuarios</PageTitle>
      <UsuariosView/>
    </>
  );
};

export {UsuariosPage}